import React from "react";
import { Icon, Form, Input, Image } from "semantic-ui-react";
import { Button } from 'components/atoms/Button/Button';
import Joi from "joi";
import { memo } from "react";
import {
    useAsyncSubmit,
  useDispatchCallback,
  useFieldset,
} from "controls/hooks";
import { forgotPassword } from "actions/authentication";

const forgotPasswordTemplate = { email: "", password: "" };
const forgotPasswordSchema = {
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .max(50)
    .required()
    .label("Email"),
};

const ForgotPassword = memo(({ history }) => {

  const moveToLogin = () => history.replace('/login');

  const {
    fields: { email },
    submit,
    loading,
  } = useFieldset({
    schema: forgotPasswordSchema,
    source: forgotPasswordTemplate,
    onSubmit: useAsyncSubmit(useDispatchCallback(forgotPassword), moveToLogin),
  });

  return (
    <div className="flex flex-column login-form container">
      <div className="ma4 flex flex-wrap items-center justify-center justify-between-ns">
        <a href="https://www.boldreuse.com/">
          <p className='login-form--return'>Return to Bold Reuse</p>
        </a>
      </div>
      <section className='flex flex-column justify-center items-center'>
          <Image src={process.env.REACT_APP_LOGO} alt='logo' size='tiny' />
      <Form
        className="w-100 center mt5 mb1 flex-column items-center justify center"
        style={{ maxWidth: 450 }}
        onSubmit={submit}
      >
        <Form.Field error={email.errored}>
          <Input
            fluid
            icon="mail"
            iconPosition="left"
            placeholder="Email"
            value={email.value}
            onChange={email.onChange}
            style={{ maxWidth: '450px', margin: '2rem auto'}}
          />
        </Form.Field>
        <Button
          type="submit"
          disabled={loading}
          loading={loading}
          primary
          fluid
          style={{ maxWidth: '180px', margin: 'auto'}}
          className='flex'
        >
          <Icon name="key" />
          Send email
        </Button>
      </Form>
      </section>
    </div>
  );
});

export default ForgotPassword;
